const Artificial = [
	{
	    path: '/Ai',
	    name: 'Ai',
	    meta: { breadcrumb: 'Ai' },
	    component: () => import('@/views/Ai/Ai.vue')
	}
]

export default Artificial